/**
 * Auth Context Definition
 * Defines the AuthContext and types - separated for fast refresh compatibility
 */

import { createContext } from 'react';
import type { User } from 'firebase/auth';
import type { BackendUser, ProfileData } from '@/types/api';

export interface AuthContextType {
  firebaseUser: User | null;
  backendUser: BackendUser | null;
  loading: boolean;
  profile: ProfileData | null;
  updateFirebaseUser: (user: User | null) => void;
  updateBackendUser: (user: BackendUser | null) => void;
  updateProfile: (profile: ProfileData | null) => void;
  switchRole: (newRole: 'tutor' | 'parent') => Promise<void>;
}

export const AuthContext = createContext<AuthContextType>({
  firebaseUser: null,
  backendUser: null,
  loading: true,
  profile: null,
  updateFirebaseUser: () => {},
  updateBackendUser: () => {},
  updateProfile: () => {},
  switchRole: async () => {},
});
